import React from 'react';
import classNames from 'classnames';

import NamedLink from '../NamedLink/NamedLink';
import { stringify } from '../../util/urlHelpers';

import css from './CategoriesDesktopMenu.module.css';

const CategoriesMenuItem = ({
  id,
  name,
  subcategories = [],
  level: prevLevel = 0,
  params: prevParams = {},
  intl,
}) => {
  const level = prevLevel + 1;
  const categoryLevelName = intl?.messages['SearchPage.filter.categoryLevel'] || 'categoryLevel';
  const params = { ...prevParams, [`pub_${categoryLevelName}${level}`]: id };
  const hasSubcategories = subcategories.length > 0;
  const hasSecondSubcategories =
    hasSubcategories && subcategories.some(subcategory => subcategory.subcategories?.length);

  return (
    <li className={css.categoriesMenuItem}>
      <NamedLink
        className={css.categoriesMenuItemLink}
        name="SearchPage"
        to={{ search: stringify(params) }}
      >
        {name}
      </NamedLink>
      {hasSubcategories && (
        <ul
          className={classNames(
            css.categoriesSubmenu,
            !hasSecondSubcategories && css.noSecondSubcategories
          )}
        >
          {subcategories.map(subcategory => (
            <CategoriesMenuItem
              key={subcategory.id}
              {...subcategory}
              {...{ level, params, intl }}
            />
          ))}
        </ul>
      )}
    </li>
  );
};

export default CategoriesMenuItem;
